export function reachGoal(name: string) {
  if (window.ym) {
    window.ym(43808394, 'reachGoal', name);
  }
}

const GOALS: { selector: string, goalName: string }[] = [
  {
    selector: '.js-click-whatsapp-goal',
    goalName: 'click-whatsapp',
  },
  {
    selector: '.js-click-telegram-goal',
    goalName: 'click-telegram',
  },
  {
    selector: '.js-click-yandex-market-goal',
    goalName: 'yandex_market',
  },
  {
    selector: '.js-click-wb-goal',
    goalName: 'link_wb',
  },
  {
    selector: '.js-click-avito-goal',
    goalName: 'avito',
  },
];

function addGoalsListener(selector: string, goalName: string) {
  const elements = document.querySelectorAll<HTMLElement>(selector);
  for (const element of elements) {
    element.addEventListener('click', () => {
      reachGoal(goalName);
    });
  }
}

export function initReachGoals() {
  for (const { selector, goalName } of GOALS) {
    addGoalsListener(selector, goalName);
  }
}
